import { Alert, AlertColor, AlertTitle, Grid, Typography } from '@mui/material';

const COLORS = {
  "SKY":"#D4F6FF",
  "GREEN":"#D1F8EF",
  "WHITE":"#FFFFFF",
  "RED":"#FFCDD2",
  "GRAY":"#ececec",
  "YELLOW":"#fff59d",
  "ORANGE":"#ff5c00",
}

export type CustomAlertCardProps = {
  alertTitle?: string;
  alertMessage?: string;
  alertContentNode?: React.ReactNode;
  alertColor?: AlertColor;
  bgColorAlert?: "SKY"|"GREEN"|"WHITE"|"RED"|"GRAY"|"YELLOW"|"ORANGE"
};

const CustomAlertCard: React.FC<CustomAlertCardProps> = ({
  alertTitle = 'INFORMACIÓN',
  alertMessage = '',
  alertContentNode,
  alertColor = 'info',
  bgColorAlert
}) => {
  return (
    <>
      <Grid item xs={12}>
        <Alert severity={alertColor} sx={{backgroundColor:bgColorAlert?COLORS[bgColorAlert]:undefined}}>
          <AlertTitle sx={{color:bgColorAlert?"black":undefined}}>{alertTitle}</AlertTitle>

          <Grid container>
            <Grid item xs={12}>
              {alertContentNode ? (
                alertContentNode
              ) : (
                <Typography variant="body1" sx={{color:bgColorAlert?"black":undefined}}>{alertMessage}</Typography>
              )}
            </Grid>
          </Grid>
        </Alert>
      </Grid>
    </>
  );
};

export default CustomAlertCard;
